// product list
export const CONTRACT_POST_REQUEST = 'CONTRACT_POST_REQUEST';
export const CONTRACT_POST_SUCCESS = 'CONTRACT_POST_SUCCESS';
export const CONTRACT_POST_ERROR = 'CONTRACT_POST_ERROR'; 
